var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMission01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.2103 150.2C116.687 150.2 150.31 116.577 150.31 75.1C150.31 33.6234 116.687 0 75.2103 0C33.7338 0 0.110352 33.6234 0.110352 75.1C0.110352 116.577 33.7338 150.2 75.2103 150.2Z",
    fill: "url(#paint0_linear_339_494)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2101 133.23C107.314 133.23 133.34 107.204 133.34 75.1C133.34 42.9957 107.314 16.97 75.2101 16.97C43.1058 16.97 17.0801 42.9957 17.0801 75.1C17.0801 107.204 43.1058 133.23 75.2101 133.23Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_339_494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.63 89.43L89.86 84.2L95.68 82.22L96.32 76.11L100.7 71.8L98.62 66.01L100.7 60.22L96.32 55.91L95.68 49.8L89.86 47.82L86.63 42.59L80.53 43.33L75.35 40L70.17 43.31L64.07 42.57L60.84 47.8L55.02 49.78L54.38 55.89L50 60.21L52.08 66L50 71.79L54.38 76.1L55.02 82.21L60.84 84.19L64.07 89.42L70.17 88.68L75.35 91.99L80.53 88.68L86.63 89.42V89.43ZM57.52 66C57.52 56.17 65.52 48.17 75.35 48.17C85.18 48.17 93.18 56.17 93.18 66C93.18 75.83 85.18 83.83 75.35 83.83C65.52 83.83 57.52 75.83 57.52 66Z",
    fill: "#F7CE0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3502 52.3101C67.8002 52.3101 61.6602 58.4501 61.6602 66.0001C61.6602 73.5501 67.8002 79.6901 75.3502 79.6901C82.9002 79.6901 89.0402 73.5501 89.0402 66.0001C89.0402 58.4501 82.9002 52.3101 75.3502 52.3101Z",
    fill: "#F7CE0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1897 92.9699L61.9297 93.8499L58.0997 87.6299L56.7997 87.1899L51.1797 104.76L61.2997 104.2L69.2197 110.53L73.8797 95.9699L69.1997 92.9799L69.1897 92.9699Z",
    fill: "#F7CE0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6001 87.6299L88.7701 93.8499L81.5101 92.9699L76.8301 95.9599L81.4901 110.52L89.4101 104.19L99.5301 104.75L93.9101 87.1799L92.6101 87.6199L92.6001 87.6299Z",
    fill: "#F7CE0E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_339_494",
    x1: 18.6704,
    y1: 124.52,
    x2: 130.84,
    y2: 26.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CE0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#F9D73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FBDF61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FCE57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FEEA94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FEEDA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEA6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_339_494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.7,
    height: 70.53,
    fill: "white",
    transform: "translate(50 40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission01);
export default __webpack_public_path__ + "static/media/Mission-01.e6bc582590e76ad982cb656d6d6cd672.svg";
export { ForwardRef as ReactComponent };